import { createI18n } from 'vue-i18n';

import messages from '@/i18n/en.json';

const localeMessages = {
	de: () => import('@/i18n/de.json'),
	en: () => import('@/i18n/en.json'),
	es: () => import('@/i18n/es.json'),
	fr: () => import('@/i18n/fr.json'),
	it: () => import('@/i18n/it.json'),
	ja: () => import('@/i18n/ja.json'),
	ko: () => import('@/i18n/ko.json'),
	pt: () => import('@/i18n/pt.json'),
	ru: () => import('@/i18n/ru.json'),
	zh: () => import('@/i18n/zh.json'),
};

type AvailableLocale = keyof typeof localeMessages;

export const i18n = createI18n({
	legacy: true,
	allowComposition: true,
	globalInjection: true,
	locale: 'en',
	silentTranslationWarn: true,
	messages: { en: messages },
});

const loadedLanguages = ['en'];

const setI18nLanguage = (lang: string): string => {
	(i18n.global as { locale: string }).locale = lang;
	document.querySelector('html')?.setAttribute('lang', lang);

	return lang;
};

const isAvailableLocale = (locale: string): locale is AvailableLocale =>
	locale in localeMessages;

export const getCurrentLocale = (): string =>
	globalThis.navigator.language.split('-')[0];

export const loadLanguageAsync = async (): Promise<string> => {
	const currentLocale = getCurrentLocale();
	const lang = isAvailableLocale(currentLocale) ? currentLocale : 'en';

	if (i18n.global.locale === lang || loadedLanguages.includes(lang)) {
		return Promise.resolve(setI18nLanguage(lang));
	}

	const loaded = await localeMessages[lang]();
	i18n.global.setLocaleMessage(lang, loaded.default as typeof messages);
	loadedLanguages.push(lang);

	return setI18nLanguage(lang);
};
